export const includesCaseInsensitive = function (a, b) {
  if (a === void 0) {
    a = '';
  }
  if (b === void 0) {
    b = '';
  }
  return !b || a.toLowerCase().indexOf(b.toLowerCase()) !== -1;
};
//# sourceMappingURL=utils.js.map